import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom'
import { iniciDesloginar, renovarTokenAction } from '../../actions/auth'
import { recuperarConfigUsuari } from '../../actions/configUsuariAction';
import { recuperarConfigAplicacio } from '../../actions/configAplicacioAction';
import { useTranslation } from 'react-i18next';
import { recuperarInfoVacancesEntreDates } from '../../actions/configCalendariAction';
import { RecuperarInfoCalendar } from '../Calendar/RecuperarInfoCalendar';

// OPTIMITZAT:
// - recuperarConfigUsuari + recuperarConfigAplicacio: 1 sola crida (eliminades de UsuariLoginat)
// - renovarTokenAction: 1 sol interval de 5 min (eliminat de UsuariLoginat)
// - dep [auth.tokenJwt] en lloc de [auth] sencer → evita re-dispatches innecessaris

export const MenuPrincipal = () => {
    const dispatch = useDispatch();
    const navegacio = useNavigate();
    const { auth, ui, calendari } = useSelector(state => state);
    const [t, i18n] = useTranslation('generic');
    const tokenRef = useRef(null);

    // ── Carregar config quan el token arriba (1 sola vegada per sessió) ───────
    useEffect(() => {
        if (!auth.tokenJwt) return;
        // Evitar re-cridar si el token no ha canviat
        if (auth.tokenJwt === tokenRef.current) return;
        tokenRef.current = auth.tokenJwt;
        dispatch(recuperarConfigUsuari(auth.tokenJwt));
        dispatch(recuperarConfigAplicacio(auth.tokenJwt));
    }, [auth.tokenJwt, dispatch]);

    // ── Renovar token cada 5 minuts (1 sol interval per tota l'app) ──────────
    useEffect(() => {
        if (!auth.tokenJwt) return;
        const interval = setInterval(() => {
            dispatch(renovarTokenAction(auth.tokenJwt));
        }, 60000 * 5);
        return () => clearInterval(interval);
    }, [auth.tokenJwt, dispatch]);

    const handleConsultarCalendari = () => {
        dispatch(RecuperarInfoCalendar(auth, ui));
    };
    const handleConsultarCalendariVaca = () => {
        dispatch(recuperarInfoVacancesEntreDates(auth.tokenJwt));
    };

    return (
        <div className='text-center mb-5'>
            {auth.resp == 1 && ui.resp == true
                ? <NavLink
                    className={({ isActive }) => 'btn btn-white btn-sm m-1 ' + (isActive ? 'active' : '')}
                    to="/calendariVacances"
                    onClick={handleConsultarCalendariVaca}
                >
                    {t('Header.CalendariVac')}
                </NavLink>
                : <>
                    {auth.admin == 0
                        ? <NavLink
                            className={({ isActive }) => 'btn btn-white btn-sm m-1 ' + (isActive ? 'active' : '')}
                            to="/"
                        >
                            {t('Header.ControlPresencia')}
                        </NavLink>
                        : null}

                    <NavLink
                        className={({ isActive }) => 'btn btn-white btn-sm m-1 ' + (isActive ? 'active' : '')}
                        to="/calendar"
                        onClick={handleConsultarCalendari}
                    >
                        {t('Header.Historic')}
                    </NavLink>

                    {auth.admin == 0
                        ? <NavLink
                            className={({ isActive }) => 'btn btn-white btn-sm m-1 ' + (isActive ? 'active' : '')}
                            to="/manuals"
                        >
                            {t('Header.Manuals')}
                        </NavLink>
                        : <NavLink
                            className={({ isActive }) => 'btn btn-white btn-sm m-1 ' + (isActive ? 'active' : '')}
                            to="/preferencies"
                        >
                            {t('Header.Preferecies')}
                        </NavLink>
                    }
                </>
            }
        </div>
    );
}